import { mockReferralDB } from './mockDb';
import type { CommissionRule, CommissionEntry, CommissionRuleFormData } from '../types';

export const commissionService = {
  async getAllRules(): Promise<CommissionRule[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getCommissionRules();
  },

  async getRuleById(id: string): Promise<CommissionRule> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const rule = mockReferralDB.getCommissionRule(id);
    if (!rule) throw new Error('Commission rule not found');
    return rule;
  },

  async createRule(data: CommissionRuleFormData): Promise<CommissionRule> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockReferralDB.createCommissionRule(data);
  },

  async updateRule(id: string, data: Partial<CommissionRuleFormData>): Promise<CommissionRule> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockReferralDB.updateCommissionRule(id, data);
    if (!updated) throw new Error('Commission rule not found');
    return updated;
  },

  async getAllEntries(): Promise<CommissionEntry[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getCommissionEntries();
  },

  async getEntryById(id: string): Promise<CommissionEntry> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const entry = mockReferralDB.getCommissionEntry(id);
    if (!entry) throw new Error('Commission entry not found');
    return entry;
  },

  async getEntriesByReferrer(referrerId: string): Promise<CommissionEntry[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getCommissionEntriesByReferrer(referrerId);
  },

  async getUnpaidEntries(): Promise<CommissionEntry[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getUnpaidCommissionEntries();
  },

  async updateEntryStatus(id: string, status: CommissionEntry['payoutStatus'], reason?: string): Promise<CommissionEntry> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockReferralDB.updateCommissionEntry(id, { payoutStatus: status, reason });
    if (!updated) throw new Error('Commission entry not found');
    return updated;
  },

  async markEntriesAsPaid(entryIds: string[]): Promise<CommissionEntry[]> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updatedEntries: CommissionEntry[] = [];
    
    for (const id of entryIds) {
      const updated = mockReferralDB.updateCommissionEntry(id, { payoutStatus: 'paid' });
      if (updated) {
        updatedEntries.push(updated);
      }
    }
    
    return updatedEntries;
  },
};
